import elementIsVisibleInViewport from '../../assets/js/utils/visible-viewport';

class Header {
    constructor(domElement) {
        if (!domElement) {
            return;
        }
        
        this.domElement = domElement;
        this.burger = this.domElement.querySelector('.header__burger')
        this.options = this.domElement.querySelectorAll('.header__options-nav-list-link');
        this.mobileMenu = this.domElement.querySelector('.header__mobile-menu');
        this.firstBlock = document.querySelector('.block-slider') ? document.querySelector('.block-slider') : null;
        this.#init();
    }
    #init() {
        this.#addEventListeners()
    }

    #addEventListeners() {
        if (!this.firstBlock) {
            this.domElement.classList.add('active');
        }

        const openMobileMenuCallback = () => this.openMobileMenu();
        this.burger.addEventListener('click', openMobileMenuCallback);

        document.addEventListener('scroll', () => {
            if (this.firstBlock) {
                this.checkHeaderPosition();
            }
        });
    }

    openMobileMenu() {
        this.#toggleBurger();
        this.#toggleMobileMenu();
    }

    #toggleMobileMenu() {
        this.mobileMenu.classList.toggle('header__mobile-menu--active');
        let isOpen = this.mobileMenu.classList.contains('header__mobile-menu--active');
        let body = document.querySelector('body')
        if(isOpen) {
            body.style.overflow = 'hidden';
        }
        else {
            body.style.overflow = '';
        }
    }

    checkHeaderPosition() {
        if (window.scrollY > 50) {
            this.domElement.classList.add('active');
        } else {
            this.domElement.classList.remove('active');
        }
    }

    #toggleBurger() {
        this.burger.classList.toggle('header__burger--active');
    }

}

const header = document.querySelector('.header');
const instanceHeader = new Header(header);

export default instanceHeader